import { createSelector } from 'reselect'

const getAudienceGrowthChart = (state: any) => state.audienceGrowthChart

/** A Redux selector to retrieve Live viewer Data
 * @param state - The Redux state
 * @param {object} - Live viewer Data.
 */

export const selectAudienceGrowthChart = createSelector(
  getAudienceGrowthChart,
  (data) => data && data.audienceGrowthChartData ? data.audienceGrowthChartData : null
)

